import React, { useEffect, useRef, useState } from "react";
import { ArrowRight } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function HeroBanner() {
  const [scrollProgress, setScrollProgress] = useState(0);
  const sectionRef = useRef<HTMLElement>(null);
  useEffect(() => {
    const handleScroll = () => {
      if (!sectionRef.current) return;
      const scrolled = window.scrollY;
      const sectionHeight = sectionRef.current.offsetHeight;
      const progress = Math.min(scrolled / sectionHeight, 1);
      setScrollProgress(scrolled);
    };
    window.addEventListener("scroll", handleScroll, {
      passive: true
    });
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const parallaxY = scrollProgress * 0.2;
  const scale = 1 + scrollProgress * 0.0005;
  return <section data-section-id="8424" id="milestone-methodology" ref={sectionRef} className="relative h-screen min-h-[600px] w-full overflow-hidden bg-primary">
      {}
      <div className="absolute inset-0 z-0" style={{
      transform: `translate3d(0, ${parallaxY}px, 0) scale(${Math.min(scale, 1.1)})`,
      transition: "transform 0.1s ease-out"
    }}>
        <div className="absolute inset-0 bg-primary/40 z-10" /> {}
        <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1595871/img/glass_skyscraper_reflection.png" alt="Abstract architectural wireframe and Auckland skyline silhouette" className="h-full w-full object-cover object-center grayscale opacity-50 contrast-150" />
      </div>

      {}
      <div className="absolute inset-0 z-10 bg-gradient-to-b from-primary/90 via-primary/80 to-primary/95 mix-blend-multiply" />
      
      {}
      <div className="relative z-20 flex h-full w-full flex-col items-center justify-center px-4 text-center sm:px-6 lg:px-8">
        <div className="max-w-4xl space-y-8">
          {}
          <h1 className="font-sans text-5xl font-black tracking-tighter text-primary-foreground sm:text-6xl md:text-7xl lg:text-8xl drop-shadow-[0_0_30px_rgba(20,184,166,0.3)]">
            We Deliver. You Lead.
          </h1>

          {}
          <p className="mx-auto max-w-2xl font-sans text-lg font-normal leading-[1.6] text-slate-400 sm:text-xl">
            Outcome-based project leadership with zero retainers and total milestone transparency. Experience the elite precision of Projectora.
          </p>

          {}
          <div className="pt-4">
            <Button asChild size="lg" className="h-14 rounded-sm bg-primary px-10 text-base font-semibold text-primary-foreground border border-primary-foreground/20 shadow-lg transition-all hover:scale-105 hover:bg-primary/90 hover:shadow-[0_0_25px_rgba(20,184,166,0.4)]">
              <Link to="/ServicesPage">
                Explore Our Methodology
                <ArrowRight className="ml-2 size-5" />
              </Link>
            </Button>
          </div>
        </div>
      </div>
    </section>;
}